import { createContext, useContext, useState } from "react";

const ScopeContext = createContext({ branchId: "", setBranchId: () => {} });
const KEY = "purchases.branchScope";

export const BranchScopeProvider = ({ children }) => {
  const [branchId, setBranch] = useState(() => localStorage.getItem(KEY) || "");
  const setBranchId = (value) => {
    localStorage.setItem(KEY, value || "");
    setBranch(value || "");
  };
  return (
    <ScopeContext.Provider value={{ branchId, setBranchId }}>{children}</ScopeContext.Provider>
  );
};

export const useBranchScope = () => useContext(ScopeContext);
